import { AuthenticationProviderType,
    DefaultAuthenticationProvider,
    IAuthenticationProvider,
    SiteAuthenticationSettingsService } from '../../../ts/services/SiteAuthenticationSettingsService';
import { SiteUrls } from '@tableau/shared-urls';
import { ServiceLocator } from '../../../app/ServiceLocator';
import { Messages } from '../../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../services/ServerSettingsUnauthenticated';
import { getSessionManagementServiceInstance } from '../../../sessionManagement/SessionManagementService';


export class AuthenticationProviderSelectorModel {
    public authenticationProviderIds: string[]; // INPUT - array form is needed for radio-button tri-state behavior
    public authenticationProvider: IAuthenticationProvider; // OUTPUT - will be set to the selected provider
    public authSetting: string;

    public getProviderDisplayName: (provider: IAuthenticationProvider) => string;
    public getProviderDescription: (provider: IAuthenticationProvider, inviteNotificationEnabledForSite: boolean) => string;

    constructor() {
        this.authenticationProviderIds = [];
        this.authenticationProvider = DefaultAuthenticationProvider;
        this.authSetting = 'DEFAULT';
        this.getProviderDisplayName = this.defaultGetProviderDisplayName;
        this.getProviderDescription = this.defaultGetProviderDescription;
    }

    public defaultGetProviderDisplayName(provider: IAuthenticationProvider): string {
      return ServiceLocator.get<SiteAuthenticationSettingsService>('SiteAuthenticationSettingsService').getProviderDisplayName(provider);
    }

    public defaultGetProviderDescription(provider: IAuthenticationProvider, inviteNotificationEnabledForSite: boolean): string {
      const getTranslation = (): string => {
          if (provider.type === AuthenticationProviderType.default) {
            if (ServerSettingsUnauthenticated.isTableauIdSupported()) {
              return Messages.addUsersWithAuthentication_description_tableauid();
            }
          } else {
            // Conditional descriptions for 1) both when the server config for site invite notifications is turned on and off and for 2) Site level settings on/off
            return getSessionManagementServiceInstance().isSiteInviteEmailEnabledForServer()
              ? (inviteNotificationEnabledForSite ?
                Messages.addUsersWithAuthentication_description_external_email() :
                Messages.addUsersWithAuthentication_description_external_email_off({SITE_INVITE_NOTIF_SETTINGS_URL: getSiteInviteUrl()}))
              : Messages.addUsersWithAuthentication_description_external(
                {SERVER_NAME: ServerSettingsUnauthenticated.serverName(),
                PROVIDER_NAME: ServiceLocator.get<SiteAuthenticationSettingsService>('SiteAuthenticationSettingsService').getProviderDisplayName(provider)});
          }
      };

      const getSiteInviteUrl = (): string => {
          const siteUrls = new SiteUrls({
            siteUrlName: getSessionManagementServiceInstance().sessionSiteUrlName(),
            queryString: window.location.search
          });
          return `<a href=${siteUrls.settingsUrl()}>${Messages.goToSiteInviteNotifSettings()}</a>`;
        };

      return getTranslation();
    }

    public updateGetProviderDisplayName(newFunc: (provider: IAuthenticationProvider) => string) {
        this.getProviderDisplayName = newFunc;
    }

    public updateGetProviderDescription(newFunc: (provider: IAuthenticationProvider, inviteNotificationEnabledForSite: boolean) => string) {
        this.getProviderDescription = newFunc;
    }

    public updateAuthenticationProvider(provider: IAuthenticationProvider) {
        this.authenticationProvider = provider;
    }

    public updateAuthenticationProviderIds(providerIds: string[]) {
        this.authenticationProviderIds = providerIds;
    }

    public updateAuthSetting(setting: string) {
        this.authSetting = setting;
    }
}